export const option_sidebar = [
  {
    label: "專案",
    path: "/back/project",
  },
];

export const option_system_web = [
  { label: "嘉義縣愛健康照護關懷服務平台", value: "HEALTHCARE_CHIAYI" },
  { label: "嘉義縣骨肌共照網", value: "HEALTHCARE_CHIAYI_BONE" },
  { label: "嘉義縣心衛中心系統", value: "HEALTHCARE_CHIAYI_PSY" },
  { label: "雲林縣民全人健康照護關懷服務系統", value: "HEALTHCARE_YUNLIN" },
  // { label: "連江縣追蹤關懷系統", value: "HEALTHCARE_MATSU" },
  // { label: "連江縣健檢管理系統", value: "HEALTHCHECK" },
  { label: "集團台北廠", value: "HEALTH_A" },
  { label: "連展/國際", value: "HEALTH_B" },
  { label: "投控", value: "HEALTH_C" },
  { label: "連訊", value: "HEALTH_D" },
  { label: "連騰", value: "HEALTH_E" },
  { label: "連淨", value: "HEALTH_F" },
  { label: "電能", value: "HEALTH_G" },
];

export const option_enabled = [
  { label: "啟用", value: 1 },
  { label: "停用", value: 0 },
];

export const option_colData = [
  "#7FA6B8", // 深淺藍
  "#E38B8B", // 玫瑰紅
  "#E6A57E", // 深蜜桃
  "#9FC5A6", // 鼠尾草綠
  "#6FB7A6", // 深薄荷
  "#9AA6D1", // 深淡紫
  "#C28AD8", // 深粉紫
  "#E0C36F", // 深淡黃
  "#A98BE0", // 深薰衣草
  "#E07A86", // 深玫瑰粉
  "#8FBF8F", // 深薄荷綠
  "#E0D36F", // 深奶油黃
  "#6FBFD6", // 深淺青藍
  "#B8B8E6", // 深薰衣草灰
  "#E0A3B5", // 深櫻花粉
  "#B08FBF", // 深蓟紫
  "#8FB3A2", // 深鼠尾草
  "#E3A7A7", // 深裸粉
  "#B99AD9", // 深淡紫粉
  "#D6C08A", // 深米杏色
];

export const option_chronic_disease = [
    { label: "1無", realLabel: "無", value: 1 },
    { label: "2高血壓", realLabel: "高血壓", value: 2 },
    { label: "3心血管疾病(心臟病)", realLabel: "心血管疾病(心臟病)", value: 3 },
    { label: "4高血脂症", realLabel: "高血脂症", value: 4 },
    { label: "5中風", realLabel: "中風", value: 5 },
    { label: "6糖尿病", realLabel: "糖尿病", value: 6 },
    { label: "7腸胃疾病", realLabel: "腸胃疾病", value: 7 },
    { label: "8白內障、青光眼", realLabel: "白內障、青光眼", value: 8 },
    { label: "9腎臟疾病(洗腎)", realLabel: "腎臟疾病(洗腎)", value: 9 },
    {
      label: "10關節炎或風濕性疾病",
      realLabel: "關節炎或風濕性疾病",
      value: 10,
    },
    {
      label: "11氣喘或慢性呼吸道疾病",
      realLabel: "氣喘或慢性呼吸道疾病",
      value: 11,
    },
    { label: "12癌症", realLabel: "癌症", value: 12 },
    { label: "13其他", realLabel: "其他", value: 13 },
  ],
  option_chronic_disease_obj = option_chronic_disease.reduce(
    (pre, cur) => ({ ...pre, [cur.label]: cur }),
    {}
  );
